type Props = {};

const Help = (props: Props) => {
  return null;
};

export default Help;
